var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7083",
    "data-name": "Rectangle 7083",
    width: 380,
    height: 160,
    transform: "translate(726 227)",
    fill: "#f0e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 124.03,
    height: 77.492,
    rx: 4,
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 124.03,
    height: 77.492,
    rx: 4,
    fill: "#dceaef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-3",
    "data-name": "SVGID",
    width: 133.56,
    height: 86.814,
    rx: 4,
    transform: "translate(31.236 1140.293)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6375",
    "data-name": "Mask Group 6375",
    transform: "translate(-726 -227)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28199",
    "data-name": "Group 28199",
    transform: "translate(6.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28184",
    "data-name": "Group 28184",
    transform: "translate(855.229 347.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M0,22.547l12.719-7.723V0L0,7.751Z",
    transform: "translate(12.719 7.516)",
    fill: "#fcea80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M12.719,22.547,0,14.824V0L12.719,7.751Z",
    transform: "translate(0 7.482)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M0,7.6,12.719,0,25.438,7.6,12.719,15.32Z",
    transform: "translate(0 0)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28185",
    "data-name": "Group 28185",
    transform: "translate(774.806 264.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31465",
    "data-name": "Path 31465",
    d: "M14.24,135.679.1,121.9l14.14,8.656Z",
    transform: "translate(-0.089 -108.155)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31466",
    "data-name": "Path 31466",
    d: "M125,135.653l14.1-13.787L125,130.517Z",
    transform: "translate(-110.905 -108.129)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31467",
    "data-name": "Path 31467",
    d: "M14.095,0,0,13.756l14.095,8.637Z",
    transform: "translate(0 0)",
    fill: "#8ce2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31468",
    "data-name": "Path 31468",
    d: "M125,0l14.095,13.756L125,22.393Z",
    transform: "translate(-110.905 0)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28186",
    "data-name": "Group 28186",
    transform: "translate(1019.281 249.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7-2",
    "data-name": "Fill 7",
    d: "M0,22.547l12.719-7.723V0L0,7.751Z",
    transform: "translate(12.719 7.516)",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8-2",
    "data-name": "Fill 8",
    d: "M12.719,22.547,0,14.824V0L12.719,7.751Z",
    transform: "translate(0 7.482)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9-2",
    "data-name": "Fill 9",
    d: "M0,7.6,12.719,0,25.438,7.6,12.719,15.32Z",
    transform: "translate(0 0)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28198",
    "data-name": "Group 28198",
    transform: "translate(832.266 231.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28197",
    "data-name": "Group 28197",
    transform: "translate(-4.529 -1.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6373",
    "data-name": "Mask Group 6373",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 74.928, 17.727)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28190",
    "data-name": "Group 28190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31469",
    "data-name": "Path 31469",
    d: "M0,0h124.03V77.493H0Z",
    transform: "translate(0 0)",
    fill: "#f8f8f8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6374",
    "data-name": "Mask Group 6374",
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 56.085, 9.139)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28194",
    "data-name": "Group 28194",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31485",
    "data-name": "Path 31485",
    d: "M0,0H124.031V77.493H0Z",
    transform: "translate(0 0)",
    fill: "#dceaef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28233",
    "data-name": "Group 28233",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 23.904, 1.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6382",
    "data-name": "Mask Group 6382",
    transform: "translate(-31.405 -1140.428)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31593",
    "data-name": "Path 31593",
    d: "M0,0H134.191V87.6H0Z",
    transform: "translate(30.921 1139.902)",
    fill: "#6c8bf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_32",
    "data-name": "Intersection 32",
    transform: "translate(91.802 1139.905)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.524,87.6,0,35.255,19.891,0H73.3V87.6Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.30416107177734 87.59535980224609 L 73.30416107177734 5.498190603248077e-06 L 19.89055061340332 5.498190603248077e-06 L -1.817052520891593e-06 35.25518035888672 L 29.52409172058105 87.59535980224609 L 73.30416107177734 87.59535980224609 M 74.30416107177734 88.59535980224609 L 28.94004440307617 88.59535980224609 L -1.148154735565186 35.25513458251953 L 19.30656242370605 -0.9999945163726807 L 74.30416107177734 -0.9999945163726807 L 74.30416107177734 88.59535980224609 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_33",
    "data-name": "Intersection 33",
    transform: "translate(30.917 1164.407)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,63.092V24.671A53.9,53.9,0,0,1,45.011,0C75.083,0,99.463,25.284,99.463,56.462a59.143,59.143,0,0,1-.373,6.63Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 99.09014129638672 63.09151458740234 C 99.33534240722656 60.9172477722168 99.46317291259766 58.70515441894531 99.46317291259766 56.46176910400391 C 99.46317291259766 25.28382110595703 75.08323669433594 -4.613647433870938e-06 45.01132965087891 -4.613647433870938e-06 C 26.30508995056152 -4.613647433870938e-06 9.803102493286133 9.777022361755371 -4.025065209134482e-06 24.67079544067383 L -4.025065209134482e-06 63.09151458740234 L 99.09014129638672 63.09151458740234 M 99.98370361328125 64.09151458740234 L -1.000004053115845 64.09151458740234 L -1.000004053115845 24.3712215423584 L -0.8352973461151123 24.12099456787109 C 1.651395916938782 20.34298133850098 4.575195789337158 16.87132835388184 7.854889392852783 13.80248832702637 C 11.14618301391602 10.7227954864502 14.78772926330566 8.056515693664551 18.67838287353516 5.877728939056396 C 22.63907623291016 3.659715414047241 26.8548755645752 1.949235439300537 31.20867538452148 0.7938220500946045 C 35.69392776489258 -0.3964712917804718 40.33781051635742 -1.000004649162292 45.01132965087891 -1.000004649162292 C 52.50103759765625 -1.000004649162292 59.7671012878418 0.52140873670578 66.60771942138672 3.521968603134155 C 69.89443969726562 4.963662147521973 73.06429290771484 6.747888565063477 76.02921295166016 8.825101852416992 C 78.9649658203125 10.88187503814697 81.7254638671875 13.24370193481445 84.23403930664062 15.84499549865723 C 86.74195861816406 18.44560813903809 89.01876831054688 21.30703544616699 91.00123596191406 24.34976959228516 C 93.00243377685547 27.42124938964844 94.72122192382812 30.70463562011719 96.10984802246094 34.10870361328125 C 98.99850463867188 41.18987655639648 100.4631729125977 48.71054077148438 100.4631729125977 56.46176910400391 C 100.4631729125977 58.7033805847168 100.3355407714844 60.97166061401367 100.0838470458984 63.20358276367188 L 99.98370361328125 64.09151458740234 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    d: "M7.455,0H126.736a7.455,7.455,0,0,1,7.455,7.455V80.142a7.455,7.455,0,0,1-7.455,7.455H7.455A7.455,7.455,0,0,1,0,80.142V7.455A7.455,7.455,0,0,1,7.455,0Z",
    transform: "translate(30.921 1139.902)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_34",
    "data-name": "Intersection 34",
    transform: "translate(91.81 1168.248)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.516,59.249,0,6.917,3.889,0c20.3,8.209,34.689,28.676,34.689,52.622a58.446,58.446,0,0,1-.376,6.627Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.20289611816406 59.24904251098633 C 38.45070648193359 57.07609176635742 38.57853317260742 54.86661148071289 38.57853317260742 52.62191390991211 C 38.57853317260742 28.67630386352539 24.18690490722656 8.209253311157227 3.88941478729248 3.162841721859877e-06 L 4.678955065173795e-06 6.916693210601807 L 29.51626396179199 59.24904251098633 L 38.20289611816406 59.24904251098633 M 39.09533309936523 60.24904251098633 L 28.93218421936035 60.24904251098633 L -1.147675275802612 6.917433261871338 L 3.448914766311646 -1.256846785545349 L 4.264354705810547 -0.9270468354225159 C 9.38609504699707 1.144423127174377 14.1779146194458 3.994783163070679 18.5067253112793 7.544873237609863 C 22.79611396789551 11.0626335144043 26.55390548706055 15.20346355438232 29.67571449279785 19.85233306884766 C 36.15419387817383 29.49981307983398 39.57853317260742 40.83134460449219 39.57853317260742 52.62191390991211 C 39.57853317260742 54.87143325805664 39.44998550415039 57.13924407958984 39.19645309448242 59.36235427856445 L 39.09533309936523 60.24904251098633 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24041",
    "data-name": "Path 24041",
    d: "M21.716.133,2.58,0A2.545,2.545,0,0,0,.086,2.591L0,14.751a2.545,2.545,0,0,0,2.458,2.626l19.136.134a2.545,2.545,0,0,0,2.494-2.592l.085-12.16A2.546,2.546,0,0,0,21.716.133Z",
    transform: "translate(9.465 30.025)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtual);
export default __webpack_public_path__ + "static/media/virtual.1d4e36923f3b63faadbe222df8f9bcbc.svg";
export { ForwardRef as ReactComponent };